import { useGetCompetitorPropertyOptions } from '~/hooks/apis/price-parity/useGetCompetitorPropertyOptions';
import { useGetCompetitorPropertySnapshot } from '~/hooks/apis/price-parity/useGetCompetitorPropertySnapshot';

import type { CompetitorProperty } from '~/types/services/priceParrot';

// A past collection's room options when one is chosen, else the current deal's.
export function useCompetitorOfferOptions(property: CompetitorProperty, collectionId?: string) {
  const current = useGetCompetitorPropertyOptions(property.sourceName, property.externalPropertyId, !collectionId);
  const snapshot = useGetCompetitorPropertySnapshot(property.sourceName, property.externalPropertyId, collectionId);
  if (!collectionId) {
    return { options: current.data ?? [], isLoading: current.isLoading, error: current.error };
  }
  return { options: snapshot.data?.options ?? [], isLoading: snapshot.isLoading, error: snapshot.error };
}
